import { render, staticRenderFns } from "./IconUploadLg.vue?vue&type=template&id=25856ca2&"
import script from "./IconUploadLg.vue?vue&type=script&lang=js&"
export * from "./IconUploadLg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25856ca2')) {
      api.createRecord('25856ca2', component.options)
    } else {
      api.reload('25856ca2', component.options)
    }
    module.hot.accept("./IconUploadLg.vue?vue&type=template&id=25856ca2&", function () {
      api.rerender('25856ca2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconUploadLg.vue"
export default component.exports